import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    component: () => import('@/views/Home.vue'),
    meta: {}
  },
  {
    path: '/login',
    name: 'Login',
    component: () => import('@/views/Login.vue'),
    meta: { guest: true }
  },
  {
    path: '/courses',
    name: 'Courses',
    component: () => import('@/views/CourseList.vue'),
    meta: {}
  },
  {
    path: '/course/video/:id',
    name: 'VideoDetail',
    component: () => import('@/views/VideoDetail.vue'),
    meta: {}
  },
  {
    path: '/course/ppt/:id',
    name: 'PPTDetail',
    component: () => import('@/views/PPTDetail.vue'),
    meta: {}
  },
  {
    path: '/profile',
    name: 'Profile',
    component: () => import('@/views/Profile.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/my-learning',
    name: 'MyLearning',
    component: () => import('@/views/MyLearning.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/ppt-preview',
    name: 'PPTPreview',
    component: () => import('@/views/PPTPreview.vue'),
    meta: {}
  },
  {
    path: '/about',
    name: 'About',
    component: () => import('@/views/AboutView.vue'),
    meta: {}
  },
  {
    path: '/welcome',
    name: 'Welcome',
    component: () => import('@/views/HomeView.vue'),
    meta: {}
  },
  // {
  //   path: '/search',
  //   name: 'Search',
  //   component: () => import('@/views/Search.vue'),
  //   meta: { requiresAuth: true }
  // },
  {
    path: '/news',
    name: 'news',
    component: () => import('@/views/news.vue')
  },
  {
    // 新闻详情页。注意必须放在 /news 之后、且路径带 :id
    path: '/news/:id',
    name: 'NewsDetail',
    component: () => import('@/views/news/detail.vue')
  },
  {
    path: '/products',
    name: 'products',
    component: () => import('@/views/ProductsList.vue')
  },
  {
    path: '/product/:id',
    name: 'ProductDetail',
    component: () => import('@/views/ProductDetail.vue')
  },
  {
    path: '/own',
    name: 'own',
    component: () => import('@/views/user/PersonalCenter.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/history',
    name: 'history',
    component: () => import('@/views/user/UserHistory.vue'),
    meta: { requiresAuth: true }
  },
  {
    // 意见反馈：仅登录用户可访问（未登录由全局守卫重定向到登录页并带回跳）
    path: '/feedback',
    name: 'feedback',
    component: () => import(/* webpackChunkName: "feedback" */ '@/views/feedback/Feedback.vue'),
    meta: { requiresAuth: true, title: '意见反馈' }
  },
  {
    path: '/resource',
    name: 'resource',
    component: () => import('@/views/resource/ResourceCenter.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/resourceDetail',
    name: 'ResourceDetail',
    component: () => import('@/views/resource/detail.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/my-authorizations',
    name: 'MyAuthorizations',
    component: () => import('@/views/user/MyAuthorizations.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/addMyAuth',
    name: 'addMyAuth',
    component: () => import('@/views/user/AddMyAuth.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/authorizationList',
    name: 'authorizationList',
    component: () => import('@/views/authorization/AuthorizationManagement.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/addAuthorization',
    name: 'addAuthorization',
    component: () => import('@/views/authorization/AddAuthorization.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/history-manage',
    name: 'history-manage',
    component: () => import('@/views/manage/HistoryManage.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/404',
    name: 'NotFound',
    component: () => import('@/views/NotFound.vue')
  },
  {
    path: '*',
    redirect: '/404'
  },
  {
    path: '/article',
    name: 'article',
    component: () => import('@/views/science-extension/article/list.vue')
  },
  // 父路由仅作为重定向，不渲染组件
  { path: '/science-extension', redirect: '/science-extension/index' },

  // 栏目首页（独立路由）
  {
    path: '/science-extension/index',
    name: 'ScienceExtensionIndex',
    component: () => import('@/views/science-extension/index.vue')
  },

  // 科学竞赛
  {
    path: '/science-extension/competition',
    component: () => import('@/views/science-extension/competition/list.vue')
  },
  {
    path: '/science-extension/competition/awards', // 静态路由放前面
    component: () => import('@/views/science-extension/competition/awards.vue')
  },
  {
    path: '/science-extension/competition/:id',   // 动态路由放后面
    component: () => import('@/views/science-extension/competition/detail.vue')
  },

  // 科普文章
  {
    path: '/science-extension/article',
    component: () => import('@/views/science-extension/article/list.vue'),
    meta: { requiresAuth: false }
  },
  {
    path: '/science-extension/article/:id',
    name: 'ArticleDetail',
    component: () => import('@/views/science-extension/article/detail.vue'),
    meta: { requiresAuth: false }
  },

  // 科普视频
  {
    path: '/science-extension/video',
    component: () => import('@/views/science-extension/video/list.vue')
  },
  {
    path: '/science-extension/video/:id',
    component: () => import('@/views/science-extension/video/play.vue')
  },

  // 互动问答
  {
    path: '/science-extension/qa',
    component: () => import('@/views/science-extension/qa/list.vue')
  },
  {
    path: '/science-extension/qa/ask',  // 静态路由放前面
    component: () => import('@/views/science-extension/qa/ask.vue')
  },
  {
    path: '/science-extension/qa/:id',  // 动态路由放后面
    component: () => import('@/views/science-extension/qa/detail.vue')
  },

  // 活动专区
  {
    path: '/science-extension/activity',
    component: () => import('@/views/science-extension/activity/list.vue')
  },
  {
    path: '/science-extension/activity/:id/album', // 注意嵌套路径，通常应独立
    component: () => import('@/views/science-extension/activity/album.vue')
  },
  {
    path: '/science-extension/activity/:id',
    component: () => import('@/views/science-extension/activity/detail.vue')
  },
  {
    path: '/orders',
    component: () => import('@/views/orders/order.vue')
  },
  // ===== 统一管理后台（el-menu 侧边栏整合所有后台模块） =====
  // ⚠️ 路径用 /manage 而非 /admin：因为 nginx 把 /admin 转发给了 Django 自带后台
  {
    path: '/manage',
    name: 'manage',
    component: () => import(/* webpackChunkName: "manage" */ '@/views/admin/AdminLayout.vue'),
    redirect: "/manage/home",
    meta: { requiresAuth: true, requiresStaff: true },
    children: [
      {
        path: "home",
        component: () => import(/* webpackChunkName: "manage" */ "@/views/admin/AdminHome.vue"),
        meta: { title: '后台首页' }
      },
      // 授权码
      {
        path: "auth-list",
        component: () => import(/* webpackChunkName: "manage" */ "@/views/authorization/AuthorizationManagement.vue"),
        meta: { title: '授权码列表' }
      },
      {
        path: "auth-add",
        component: () => import(/* webpackChunkName: "manage" */ "@/views/authorization/AddAuthorization.vue"),
        meta: { title: '新增授权码' }
      },
      // 科普拓展
      {
        path: "science-article-categories",
        component: () => import(/* webpackChunkName: "manage" */ "@/views/science-extension/manage/article/categories.vue"),
        meta: { title: '文章板块' }
      },
      {
        path: "science-article-list",
        component: () => import(/* webpackChunkName: "manage" */ "@/views/science-extension/manage/article/ArticleList.vue"),
        meta: { title: '文章列表' }
      },
      {
        path: "science-add-article",
        component: () => import(/* webpackChunkName: "manage" */ "@/views/science-extension/manage/article/AddArticle.vue"),
        meta: { title: '新增文章' }
      },
      {
        path: "science-edit-article/:id",
        component: () => import(/* webpackChunkName: "manage" */ "@/views/science-extension/manage/article/edit.vue"),
        meta: { title: '编辑文章' }
      },
      {
        path: "science-competition-list",
        component: () => import(/* webpackChunkName: "manage" */ "@/views/science-extension/manage/competition/list.vue"),
        meta: { title: '竞赛列表' }
      },
      {
        path: "science-video-list",
        component: () => import(/* webpackChunkName: "manage" */ "@/views/science-extension/manage/video/list.vue"),
        meta: { title: '视频列表' }
      },
      {
        path: "science-qa-list",
        component: () => import(/* webpackChunkName: "manage" */ "@/views/science-extension/manage/qa/list.vue"),
        meta: { title: '问答列表' }
      },
      {
        path: "science-activity-list",
        component: () => import(/* webpackChunkName: "manage" */ "@/views/science-extension/manage/activity/list.vue"),
        meta: { title: '活动列表' }
      },
      // 科教器材
      {
        path: "equipment-list",
        component: () => import(/* webpackChunkName: "manage" */ "@/views/equipment/manage/list.vue"),
        meta: { title: '器材列表' }
      },
      {
        path: "equipment-add",
        component: () => import(/* webpackChunkName: "manage" */ "@/views/equipment/manage/edit.vue"),
        meta: { title: '新增器材' }
      },
      {
        path: "equipment-edit/:id",
        component: () => import(/* webpackChunkName: "manage" */ "@/views/equipment/manage/edit.vue"),
        meta: { title: '编辑器材' }
      },
      {
        path: "equipment-categories",
        component: () => import(/* webpackChunkName: "manage" */ "@/views/equipment/manage/categories.vue"),
        meta: { title: '器材分类' }
      },
      // 新闻动态
      {
        path: "news-list",
        component: () => import(/* webpackChunkName: "manage" */ "@/views/news/manage/list.vue"),
        meta: { title: '新闻列表' }
      },
      {
        path: "news-add",
        component: () => import(/* webpackChunkName: "manage" */ "@/views/news/manage/edit.vue"),
        meta: { title: '新增新闻' }
      },
      {
        path: "news-edit/:id",
        component: () => import(/* webpackChunkName: "manage" */ "@/views/news/manage/edit.vue"),
        meta: { title: '编辑新闻' }
      },
      {
        path: "news-categories",
        component: () => import(/* webpackChunkName: "manage" */ "@/views/news/manage/categories.vue"),
        meta: { title: '新闻分类' }
      },
      // 财务
      {
        path: "finance-records",
        component: () => import(/* webpackChunkName: "manage" */ "@/views/finance/manage/list.vue"),
        meta: { title: '收款记录' }
      },
      // 数据（提前到首页之后）
      {
        path: "analysis-browse",
        component: () => import(/* webpackChunkName: "manage" */ "@/views/manage/HistoryManage.vue"),
        meta: { title: '浏览分析' }
      },
      {
        path: "analysis-users",
        component: () => import(/* webpackChunkName: "manage" */ "@/views/manage/UserManage.vue"),
        meta: { title: '用户分析' }
      },
      // 用户反馈（管理员查看与处理）
      {
        path: "feedback-list",
        component: () => import(/* webpackChunkName: "manage" */ "@/views/feedback/manage/list.vue"),
        meta: { title: '用户反馈' }
      },
    ]
  },

  {
    path: '/science-manage',
    name: 'science-manage',
    component: () => import(/* webpackChunkName: "science-manage" */ '@/views/science-extension/manage/bar.vue'),
    redirect: "/science-manage/index",
    children: [
      {
        path: "index",
        component: () => import(/* webpackChunkName: "science-manage" */ "@/views/science-extension/manage/index.vue")
      },
      {
        path: "article-categories",
        component: () => import(/* webpackChunkName: "science-manage" */ "@/views/science-extension/manage/article/categories.vue")
      },
      {
        path: "article-list",
        component: () => import(/* webpackChunkName: "science-manage" */ "@/views/science-extension/manage/article/ArticleList.vue")
      },
      {
        path: "addArticle",
        component: () => import(/* webpackChunkName: "science-manage" */ "@/views/science-extension/manage/article/AddArticle.vue")
      },
      {
        path: "editArticle/:id",
        component: () => import(/* webpackChunkName: "science-manage" */ "@/views/science-extension/manage/article/edit.vue")
      },
      {
        path: "competition-list",
        component: () => import(/* webpackChunkName: "science-manage" */ "@/views/science-extension/manage/competition/list.vue")
      },
      {
        path: "addCompetition",
        component: () => import(/* webpackChunkName: "science-manage" */ "@/views/science-extension/manage/competition/add.vue")
      },
      {
        path: "editCompetition/:id",
        component: () => import(/* webpackChunkName: "science-manage" */ "@/views/science-extension/manage/competition/edit.vue")
      },
      {
        path: "award-list",
        component: () => import(/* webpackChunkName: "science-manage" */ "@/views/science-extension/manage/competition/awardManage.vue")
      },
      {
        path: "video-categories",
        component: () => import(/* webpackChunkName: "science-manage" */ "@/views/science-extension/manage/video/categories.vue")
      },
      {
        path: "video-list",
        component: () => import(/* webpackChunkName: "science-manage" */ "@/views/science-extension/manage/video/list.vue")
      },
      {
        path: "addVideo",
        component: () => import(/* webpackChunkName: "science-manage" */ "@/views/science-extension/manage/video/AddVideo.vue")
      },
      {
        path: "editVideo/:id",
        component: () => import(/* webpackChunkName: "science-manage" */ "@/views/science-extension/manage/video/edit.vue")
      },
      {
        path: "qa-categories",
        component: () => import(/* webpackChunkName: "science-manage" */ "@/views/science-extension/manage/qa/categories.vue")
      },
      {
        path: "qa-list",
        component: () => import(/* webpackChunkName: "science-manage" */ "@/views/science-extension/manage/qa/list.vue")
      },
      {
        path: "activity-list",
        component: () => import(/* webpackChunkName: "science-manage" */ "@/views/science-extension/manage/activity/list.vue")
      },
      {
        path: "album",
        component: () => import(/* webpackChunkName: "science-manage" */ "@/views/science-extension/manage/activity/album.vue")
      },
      {
        path: "review",
        component: () => import(/* webpackChunkName: "science-manage" */ "@/views/science-extension/manage/activity/review.vue")
      },
    ]
  },

  // ===== 科教器材管理端（需登录，且为管理员） =====
  {
    path: '/equipment-manage',
    name: 'equipment-manage',
    component: () => import(/* webpackChunkName: "equipment-manage" */ '@/views/equipment/manage/bar.vue'),
    redirect: "/equipment-manage/list",
    meta: { requiresAuth: true, requiresStaff: true },
    children: [
      {
        path: "list",
        component: () => import(/* webpackChunkName: "equipment-manage" */ "@/views/equipment/manage/list.vue")
      },
      {
        path: "add",
        component: () => import(/* webpackChunkName: "equipment-manage" */ "@/views/equipment/manage/edit.vue")
      },
      {
        path: "edit/:id",
        component: () => import(/* webpackChunkName: "equipment-manage" */ "@/views/equipment/manage/edit.vue")
      },
      {
        path: "categories",
        component: () => import(/* webpackChunkName: "equipment-manage" */ "@/views/equipment/manage/categories.vue")
      },
    ]
  },

  // ===== 新闻动态管理端（需登录，且为管理员） =====
  {
    path: '/news-manage',
    name: 'news-manage',
    component: () => import(/* webpackChunkName: "news-manage" */ '@/views/news/manage/bar.vue'),
    redirect: "/news-manage/list",
    meta: { requiresAuth: true, requiresStaff: true },
    children: [
      {
        path: "list",
        component: () => import(/* webpackChunkName: "news-manage" */ "@/views/news/manage/list.vue")
      },
      {
        path: "add",
        component: () => import(/* webpackChunkName: "news-manage" */ "@/views/news/manage/edit.vue")
      },
      {
        path: "edit/:id",
        component: () => import(/* webpackChunkName: "news-manage" */ "@/views/news/manage/edit.vue")
      },
      {
        path: "categories",
        component: () => import(/* webpackChunkName: "news-manage" */ "@/views/news/manage/categories.vue")
      },
    ]
  },

  // ===== 收款记录 / 财务管理端（需登录，且为管理员） =====
  {
    path: '/finance-manage',
    name: 'finance-manage',
    component: () => import(/* webpackChunkName: "finance-manage" */ '@/views/finance/manage/bar.vue'),
    redirect: "/finance-manage/records",
    meta: { requiresAuth: true, requiresStaff: true },
    children: [
      {
        path: "records",
        component: () => import(/* webpackChunkName: "finance-manage" */ "@/views/finance/manage/list.vue")
      },
    ]
  },
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
  scrollBehavior() {
    return { x: 0, y: 0 }
  }
})

// 路由守卫
router.beforeEach((to, from, next) => {
  // ★ 新增：所有 /science-extension 开头的路由直接放行
  if (to.path.startsWith('/science-extension')) {
    next();
    return;
  }

  const isAuthenticated = localStorage.getItem('userState') 
    ? JSON.parse(localStorage.getItem('userState')).isAuthenticated 
    : false

  // 管理员页面：需登录且 is_staff，否则回首页
  if (to.matched.some(r => r.meta && r.meta.requiresStaff)) {
    if (!isAuthenticated) {
      next('/login')
      return
    }
    const state = localStorage.getItem('userState')
      ? JSON.parse(localStorage.getItem('userState'))
      : null
    const isStaff = state && state.info && state.info.is_staff
    if (!isStaff) {
      next('/')
      return
    }
  }
  
  // 检查是否需要登录
  if (to.meta.requiresAuth && !isAuthenticated) {
    next('/login')
  } 
  // 已登录用户访问游客页面时重定向到首页
  else if (to.meta.guest && isAuthenticated) {
    next('/')
  } 
  else {
    next()
  }
})

export default router